module.exports = __webpack_public_path__ + "static/media/r54.ceb59504.jpg";